<template>
  <section :class="['payment-icon-list', isMobile ? '' : 'desktop']">
    <div class="title">{{ $t('wallet.select_payment') }}</div>
    <section class="payment-list">
      <div
        v-for="(item, index) in paymentDatas"
        :key="index"
        @click="selectPayment(item)"
        :class="[
          'payment-item',
          item.active ? 'active' : '',
          index === paymentDatas.length - 1 ? 'exposure-target' : '',
          (index + 1) % 4 === 0 ? 'right-item' : '',
        ]"
        :style="{ display: item.show ? 'block' : 'none' }"
      >
        <template>
          <div
            :class="['img-wrap', region]"
            :style="{ backgroundImage: `url(${encodeURI(item.logo)})` }"
          ></div>
        </template>
        <p :class="['pay-name', region]">{{ item.payMethodName }}</p>
      </div>
    </section>
    <!-- <div class="payment-fold-btn" v-if="paymentDatas.length > 4" >
      <div @click="switchPaymentsFold" class="fold-btn">
        <span v-if="paymentsFolded">{{$t(`common.unfold`)}}</span>
        <span v-else>{{$t(`common.fold`)}}</span>
        <van-icon
          :name="paymentsFolded
            ? 'arrow-down'
            : 'arrow-up'"
          color="#D8D8D8" />
      </div>
    </div> -->
  </section>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'payment-icon-list',
    props: {
      channelList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        paymentsFolded: true,
      }
    },
    computed: {
      ...mapState(['region', 'isMobile']),
      paymentDatas() {
        return this.channelList
      },
    },
    methods: {
      selectPayment(item) {
        this.$emit('selectPayment', item)
      },
      switchPaymentsFold() {
        this.paymentsFolded = !this.paymentsFolded
      },
    },
  }
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
